import script from "./Comments.vue?vue&type=script&setup=true&lang=ts"
export * from "./Comments.vue?vue&type=script&setup=true&lang=ts"

import "./Comments.vue?vue&type=style&index=0&id=7a6fe275&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a6fe275"]])

export default __exports__